var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-page"},[_c('v-row',{staticClass:"pl-2"},[_c('v-col',{staticClass:"content-col",attrs:{"cols":"12"}},[_c('Form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }